import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { COMING_SOON } from "../../data/catalog";
import { FadeUp, MaskLines } from "../site/Reveal";
import { ComingSoonCard } from "./ComingSoonCard";

export const ComingSoon = () => (
  <section className="bg-ivory py-24 md:py-36" data-testid="coming-soon-section">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10">
      <div className="mb-12 flex flex-col justify-between gap-6 md:mb-16 md:flex-row md:items-end">
        <div>
          <p className="label-mono">The world of MARKHOR · Coming soon</p>
          <MaskLines inView lines={["More is", <em key="m">on the way.</em>]} className="mt-4 font-display text-5xl font-light leading-[0.92] text-ink md:text-7xl lg:text-8xl" />
        </div>
        <FadeUp className="max-w-sm">
          <p className="text-sm leading-relaxed text-graphite">Footwear, clothing, traditional footwear and travel bags — designed with the same quiet confidence.</p>
          <Link to="/coming-soon" data-testid="coming-soon-view-all" className="link-line mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ink">See everything <ArrowRight className="h-3.5 w-3.5" /></Link>
        </FadeUp>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[420px_420px]">
        {COMING_SOON.map((item, i) => (
          <ComingSoonCard key={item.id} item={item} delay={(i % 4) * 0.05} className={i === 0 || i === COMING_SOON.length - 1 ? "sm:col-span-2" : ""} />
        ))}
      </div>
    </div>
  </section>
);
